import React from 'react';
import { ArcStack } from '@src/core/ui';
import ChecklistItem from '../checklist-item';
import { ChecklistListProps } from './types';

const ChecklistList: React.FC<ChecklistListProps> = ({ items, checkedItems, onItemToggle }) => {
  return (
    <ArcStack spacing={1}>
      {items.map((item) => (
        <ChecklistItem
          key={item.id}
          item={item}
          checked={checkedItems[item.id] || false}
          onToggle={onItemToggle}
        />
      ))}
    </ArcStack>
  );
};

export default ChecklistList;

